"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertShareDataV2 = exports.PlatformType = exports.UIType = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
const utils_1 = require("./utils");
const SmartRebalanceProcessor_1 = require("../../Trading/SmartRebalance/SmartRebalanceProcessor");
var UIType;
(function (UIType) {
    UIType["userInfo"] = "userInfo";
    UIType["pnlInfo"] = "pnlInfo";
    UIType["coinList"] = "coinList";
    UIType["title"] = "title";
    UIType["paramList"] = "paramList";
})(UIType || (exports.UIType = UIType = {}));
var PlatformType;
(function (PlatformType) {
    PlatformType["web"] = "web";
    PlatformType["app"] = "app";
})(PlatformType || (exports.PlatformType = PlatformType = {}));
const convertShareDataV2 = (platformType, responseData, str) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const orderData = TradeAPILib_1.TradeUtils.convertToExchangeOrder(responseData.bu_order);
    const webDataTemp = [];
    const appDataTemp = [];
    const userInfo = {
        avatar: responseData.user_info.head_path,
        nickname: responseData.user_info.nickname,
        symbol: `${orderData === null || orderData === void 0 ? void 0 : orderData.baseDisplay}/${orderData === null || orderData === void 0 ? void 0 : orderData.quote}`,
        strategy: (_a = orderData === null || orderData === void 0 ? void 0 : orderData.orderType) !== null && _a !== void 0 ? _a : "",
    };
    if ((orderData === null || orderData === void 0 ? void 0 : orderData.orderType) === TradeAPILib_1.ExchangeOrderType.SR) {
        userInfo.symbol = "";
        userInfo.strategy = "rebalanced_bot";
    }
    webDataTemp.push({
        uiType: UIType.userInfo,
        data: userInfo,
    });
    // annual info
    if ((orderData === null || orderData === void 0 ? void 0 : orderData.orderType) === TradeAPILib_1.ExchangeOrderType.SR) {
        const getLastDesc = (createTime) => {
            const timeResult = (0, utils_1.getFormatTimeLasting)(new Date().getTime() - createTime);
            let desc = `${timeResult.hour}${str("grid_order_lasting_hour")} ${timeResult.minute}${str("grid_order_lasting_minute")}`;
            if (Number(timeResult.day) > 0) {
                desc = `${timeResult.day}${str("grid_order_lasting_day")}` + desc;
            }
            return desc;
        };
        const profitPercent = (0, utils_1.profitPercentCreator)(orderData);
        const annualized = (0, utils_1.annualizedCreator)(profitPercent, orderData);
        const pnlInfo = {
            uiType: UIType.pnlInfo,
            data: {
                annualized: `${Number(profitPercent) > 0 ? "+" : ""}${profitPercent}%`,
                details: [
                    [str("annualized_return"), annualized],
                    [str("lasting"), getLastDesc(((_b = orderData === null || orderData === void 0 ? void 0 : orderData.exchangeSROrder) === null || _b === void 0 ? void 0 : _b.triggerTime) || orderData.timestamp)],
                    [str("grid_share_sr_rebalance_new_count"), (_d = (_c = orderData === null || orderData === void 0 ? void 0 : orderData.exchangeSROrder) === null || _c === void 0 ? void 0 : _c.rebalanceRecordCount) !== null && _d !== void 0 ? _d : "--"],
                ],
            },
        };
        webDataTemp.push(pnlInfo);
    }
    if ((orderData === null || orderData === void 0 ? void 0 : orderData.orderType) === TradeAPILib_1.ExchangeOrderType.SR) {
        const title = { uiType: UIType.title };
        let rebalanceDesc = str("sr_rules_modify_by_time_interval_none");
        const rebalanceData = {
            uiType: UIType.paramList,
            data: [],
        };
        if ((_e = orderData === null || orderData === void 0 ? void 0 : orderData.exchangeSROrder) === null || _e === void 0 ? void 0 : _e.rebalanceEnabled) {
            if (orderData.exchangeSROrder.rebalanceTriggerType === TradeAPILib_1.SmartRebalanceMode.periodic) {
                const paramV = new trade_utils_lib_1.SafeDecimal(orderData.exchangeSROrder.rebalanceParam).div(new trade_utils_lib_1.SafeDecimal(60)).toNumber();
                if (paramV < 60) {
                    rebalanceDesc = str("sr_rebalance_strategy_mode", { value: `${paramV}${str("strateg_Min")}` });
                }
                else {
                    const balanceTime = new trade_utils_lib_1.SafeDecimal(paramV).div(new trade_utils_lib_1.SafeDecimal(60));
                    rebalanceDesc = str("sr_rebalance_strategy_mode", { value: `${balanceTime}${str("strateg_Hour")}` });
                }
                rebalanceData.data.push({ title: str("sr_switch_mode_type"), value: String(rebalanceDesc) });
            }
            if (orderData.exchangeSROrder.rebalanceTriggerType === TradeAPILib_1.SmartRebalanceMode.threshold) {
                const percent = trade_utils_lib_1.NumberCommonUtils.toPercent(new trade_utils_lib_1.SafeDecimal(orderData.exchangeSROrder.rebalanceParam).mul(100), false, true, 2);
                rebalanceDesc = str("sr_enter_alert_trigger_threshold_desc", { percent: percent });
                rebalanceData.data.push({ title: str("sr_switch_mode_type"), value: String(rebalanceDesc) });
            }
            if (orderData.exchangeSROrder.rebalanceTriggerType === TradeAPILib_1.SmartRebalanceMode.momentum) {
                rebalanceDesc = str("sr_switch_momentum");
                rebalanceData.data.push({ title: str("sr_switch_mode_type"), value: String(rebalanceDesc) });
                let param = { percents: [], interval: "900", sub_type: undefined, ror: undefined, check_profit: undefined };
                try {
                    param = JSON.parse(orderData.exchangeSROrder.rebalanceParam);
                }
                catch (error) { }
                rebalanceData.data.push({
                    title: str("sr_switch_momentum_method"),
                    value: param.sub_type === TradeAPILib_1.SRMomentumSubtype.momentum_threshold
                        ? str("sr_switch_momentum_sub_type_threshold")
                        : str("sr_switch_momentum_sub_type_periodic"),
                });
                if (param.sub_type === TradeAPILib_1.SRMomentumSubtype.momentum_threshold) {
                    const display = (_f = SmartRebalanceProcessor_1.SmartRebalanceProcessor.getSheetMomentumThresholdRorDisplay(param.ror)) === null || _f === void 0 ? void 0 : _f.title;
                    !!display &&
                        rebalanceData.data.push({
                            title: str("sr_switch_momentum_roi"),
                            value: display,
                        });
                }
                else {
                    rebalanceData.data.push({
                        title: str("sr_switch_momentum_period"),
                        value: str("sr_switch_momentum_period_desc", {
                            time: ((_g = SmartRebalanceProcessor_1.SmartRebalanceProcessor.getSheetMomentumPeriodDisplay(param.interval, str)) === null || _g === void 0 ? void 0 : _g.title) || "",
                        }),
                    });
                    rebalanceData.data.push({
                        title: str("sr_switch_momentum_mode"),
                        value: param.check_profit ? str("switch_on") : str("switch_off"),
                    });
                    const rorDisplay = SmartRebalanceProcessor_1.SmartRebalanceProcessor.getSheetMomentumThresholdRorDisplay(param.ror);
                    param.check_profit &&
                        rorDisplay &&
                        rebalanceData.data.push({
                            title: str("sr_switch_momentum_mode_roi"),
                            value: rorDisplay.title,
                        });
                }
                rebalanceData.data.push({
                    title: str("sr_switch_momentum_ratio"),
                    value: str("sr_switch_momentum_ratio_desc", {
                        percents: param.percents.map((item) => trade_utils_lib_1.NumberCommonUtils.toPercent(Number(item) * 100, false, true, 0)).join("、"),
                    }),
                });
            }
        }
        if ((_h = orderData.exchangeSROrder) === null || _h === void 0 ? void 0 : _h.stopLossPercent) {
            rebalanceData.data.push({
                title: str("martingale_stop_loss_percentage"),
                value: trade_utils_lib_1.NumberCommonUtils.toPercent(new trade_utils_lib_1.SafeDecimal((_j = orderData.exchangeSROrder) === null || _j === void 0 ? void 0 : _j.stopLossPercent).mul(100), false),
            });
        }
        if ((_k = orderData.exchangeSROrder) === null || _k === void 0 ? void 0 : _k.stopProfitPercent) {
            rebalanceData.data.push({
                title: str("martingale_take_profit_percentage"),
                value: trade_utils_lib_1.NumberCommonUtils.toPercent(new trade_utils_lib_1.SafeDecimal((_l = orderData.exchangeSROrder) === null || _l === void 0 ? void 0 : _l.stopProfitPercent).mul(100), false),
            });
        }
        const details = (_m = orderData === null || orderData === void 0 ? void 0 : orderData.exchangeSROrder) === null || _m === void 0 ? void 0 : _m.coins.filter((coinFilter) => {
            var _a;
            if (coinFilter.isDeleted)
                return false;
            if (((_a = orderData === null || orderData === void 0 ? void 0 : orderData.exchangeSROrder) === null || _a === void 0 ? void 0 : _a.rebalanceTriggerType) === TradeAPILib_1.SmartRebalanceMode.momentum) {
                return new trade_utils_lib_1.SafeDecimal(coinFilter.percent).greaterThanOrEqualTo(0);
            }
            return new trade_utils_lib_1.SafeDecimal(coinFilter.percent).greaterThan(0);
        }).map((item) => {
            var _a;
            return (_a = ({
                coinBase: item.base,
                coin: item.baseDisplay,
                percent: trade_utils_lib_1.NumberCommonUtils.toPercent(new trade_utils_lib_1.SafeDecimal(item.percent).mul(100).toString(), false),
            })) !== null && _a !== void 0 ? _a : null;
        }).sort((a, b) => parseFloat(b.percent) - parseFloat(a.percent));
        const coinListData = {
            uiType: UIType.coinList,
            data: {
                details: details,
            },
        };
        appDataTemp.push(coinListData);
        appDataTemp.push(rebalanceData);
        webDataTemp.push(title);
        webDataTemp.push(rebalanceData);
        webDataTemp.push(coinListData);
    }
    if (platformType === PlatformType.web) {
        return webDataTemp;
    }
    if (platformType === PlatformType.app) {
        return appDataTemp;
    }
    return [];
};
exports.convertShareDataV2 = convertShareDataV2;
